import axiosInstance from "../../../../app/myAxiosInstance";

const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;


async function getVendorSettlementsData(data) {
  try {
    const result = await axiosInstance.get(`${baseApiUrl}admin/vendor-settlements`, { params: data });
    return result;
  } catch (err) {
    console.error('error in getVendorSettlementsData ', err);
  }
}


async function getVendorSettlementById(id) {
  try {
    const result = await axiosInstance.get(`${baseApiUrl}admin/vendor-settlements/${id}`);
    return result;
  } catch (err) {
    console.error('error in getVendorSettlementById ', err);
  }
}

async function initiateTransfer(data) {
  try {
    const result = await axiosInstance.post(`${baseApiUrl}admin/vendor-settlements/transfer`, data);
    return result;
  } catch (err) {
    console.error('error in initiateTransfer ', err);
  }
}

async function closeSettlement(id) {
  try {
    const result = await axiosInstance.patch(`${baseApiUrl}admin/vendor-settlements/${id}/close`);
    return result;
  } catch (err) {
    console.error('error in closeSettlement ', err);
  }
}

async function uploadFileDirect(formData) {
  try {
    const result = await axiosInstance.post(`${baseApiUrl}admin/files/batchCreate`, formData);
    return result;
  } catch (err) {
    console.error('error in uploadFileDirect', err);
  }
}


async function getPreSignedFileURL(data) {
  try {
    const result = await axiosInstance.get(
      `${baseApiUrl}admin/beatsFiles/getPreSignedFileUrl`,
      {
        params: data
      }
    );
    return result;
  } catch (err) {
    console.log("error in getPreSignedFileURL", err);
  }
}

export const VendorSettlementsServices = {
  getVendorSettlementsData,
  getVendorSettlementById,
  initiateTransfer,
  closeSettlement,
  uploadFileDirect,
  getPreSignedFileURL
};
